import { Checkbox } from 'antd';
import { useRouter } from 'next/router';
import { useState } from 'react';

import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { submitScribe } from '@elem/Service/next-level-power';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import { termsTran, textTran } from '../../../config/subscribe';
import styles from './index.module.scss';

const CheckboxGroup = Checkbox.Group;

export const SITE_ID: any = {
    eu: '4427',
    uk: '4430',
    de: '4425',
    fr: '4428',
    it: '4429',
    es: '4426',
    us: '4423',
    ca: '4424',
};

export const CONTACT_LIST_ID: any = {
    eu: '324184408',
    uk: '16182394',
    de: '236549250',
    fr: '1053269597',
    it: '1998934371',
    es: '1772671024',
    us: '1157235157',
    ca: '1157235157',
};

// const PRODUCT_MAP: any = {
//     'delta 3 series': {
//         id: '11150',
//         type: 'multiple',
//         value: 1,
//         overwrite: false,
//     },
//     'river 3 series': {
//         id: '11150',
//         type: 'multiple',
//         value: 2,
//         overwrite: false,
//     },
//     rapid: {
//         id: '11150',
//         type: 'multiple',
//         value: 3,
//         overwrite: false,
//     },
//     'power kits': {
//         id: '11150',
//         type: 'multiple',
//         value: 4,
//         overwrite: false,
//     },
// };

const getLabels = (arr: any, originData: any) => {
    const formatArr = arr
        .map((item: any) => {
            const found = originData.find((obj: any) => obj.value === item);
            return found ? found.label : null;
        })
        .filter((label: any) => label !== null);

    return `${formatArr.join('_')}`;
};

const SelectProducts = ({ onChange, value }: any) => {
    const { t } = useLang('fourinone.teaser');
    const productOptions = [
        { value: 1, label: t('sign_up_select_product_1') },
        { value: 2, label: t('sign_up_select_product_2') },
        { value: 3, label: t('sign_up_select_product_3') },
        { value: 4, label: t('sign_up_select_product_4') },
    ];
    const handleCheckChange = (value: any) => {
        onChange && onChange(value);
    };
    return (
        <div className="select-product-box">
            <p className="select-product-title">{t('sign_up_select_tip')}</p>
            <CheckboxGroup value={value} onChange={handleCheckChange}>
                {productOptions.map((item, index) => (
                    <Checkbox key={index} value={item.value}>
                        {item.label}
                    </Checkbox>
                ))}
            </CheckboxGroup>
        </div>
    );
};

export default function SignUp() {
    const { t } = useLang('fourinone.teaser');
    const { locale }: any = useRouter();
    const [isShowOutTips, setIsShowOutTips] = useState(false);
    const [outTipsText, setOutTipsText] = useState('');
    const [outTipsType, setOutTipsType] = useState('error');
    const [products, setProducts] = useState([1, 2, 3, 4]);

    const productOptions = [
        { value: 1, label: t('sign_up_select_product_1') },
        { value: 2, label: t('sign_up_select_product_2') },
        { value: 3, label: t('sign_up_select_product_3') },
        { value: 4, label: t('sign_up_select_product_4') },
    ];

    const handleProductChange = (value: any) => {
        setProducts(value);
        if (value && value.length) {
            setTipsHandle(false);
        } else {
            setTipsHandle(true);
        }
    };
    // 提示语显示
    const setTipsHandle = (flag: boolean) => {
        if (flag) {
            setOutTipsType('error');
            setIsShowOutTips(true);
            setOutTipsText(t('sign_up_select_error_tip'));
        } else {
            setIsShowOutTips(false);
            setOutTipsText('');
        }
    };
    // 点击提交
    const clickEmarsysHandle = (data: any, callback: any) => {
        console.log(data, 'data=====');
        if (products.length === 0) {
            setTipsHandle(true);
        }
        setTipsHandle(false);

        const finalData = {
            ...data,
            source: 'WEB_NEW_PRODUCT_SUB',
        };
        handleSubmit(finalData, callback);
        return true; //停止内部的接口
    };

    const handleSubmit = async (data: any, callback: any) => {
        const finalProductsLabel = getLabels(products, productOptions);
        try {
            const res = await submitScribe(locale, data, {
                sector_name: t('sign_up_title'),
                entry_position: 3,
            });
            if (res?.code === '0') {
                setOutTipsType('success');
                setIsShowOutTips(true);
                setOutTipsText(t('sign_up_success_tip'));
                callback && callback('success', { product_name: finalProductsLabel });
            } else {
                setOutTipsType('error');
                setIsShowOutTips(true);
                setOutTipsText(res?.message);
                callback && callback(res?.message || 'fail', { product_name: finalProductsLabel });
            }
        } catch (error: any) {
            setOutTipsType('error');
            setIsShowOutTips(true);
            setOutTipsText(error);
        }
    };

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const fields = [
        // 站点字段
        {
            id: SITE_ID[locale],
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // Opt-In
        {
            id: '31',
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // 订阅日期
        {
            id: '11149',
            type: 'text',
            value: dateString,
            overwrite: true,
        },
        // 产品字段
        {
            id: '11150',
            type: 'multiple',
            value: products,
            overwrite: false,
        },
    ];

    return (
        <div className={styles.SignUp}>
            <div className="sign-up-box ef-container">
                <div className="sign-up-wrapper">
                    <div className={`sign-up-item-bg`}>
                        <NextImage src="https://websiteoss.ecoflow.com/upload/image/1724124264418/sign_bg_2.jpg" alt="sign-up-img" />
                    </div>
                    <div className={`sign-up-item-bg-pad`}>
                        <NextImage src="https://websiteoss.ecoflow.com/upload/image/1724123009396/sign_bg_pad_2.jpg" alt="sign-up-img" />
                    </div>
                    <div className={`sign-up-item-bg-h5`}>
                        <NextImage src="https://websiteoss.ecoflow.com/upload/image/1724138945362/sign_bg_h5_2.jpg" alt="sign-up-img" />
                    </div>

                    <div className={`sign-up-item-content sign-up-item-content-${outTipsType}`}>
                        {/* <div className="sign-up-icon">
                            <img src="https://websiteoss.ecoflow.com/upload/image/1721207158060/gift_icon.png" alt="sign up icon" />
                        </div> */}

                        <p className="sign-up-title">{t('sign_up_title')}</p>
                        <SelectProducts value={products} onChange={handleProductChange} />

                        <EfEmarsysEmail
                            isOpenOutTips={true}
                            isShowOutTips={isShowOutTips}
                            outTipsText={outTipsText}
                            onBeforeSendCallback={clickEmarsysHandle}
                            contactListId={CONTACT_LIST_ID[locale]}
                            fields={fields}
                            needTerms={true}
                            tipsObj={textTran[locale] || textTran.us}
                            termsHtml={termsTran[locale] || termsTran.us}
                            gtm_event_name="product_como_submit"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
